import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Loader2, Download } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { useOrganization } from '@/contexts/OrganizationContext';
import { trpc } from '@/lib/trpc';
import { downloadMasterInventoryCsv } from '../api/organizationApi';
import { toast } from 'sonner';

export default function InventorySettings() {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Inventory Reports</CardTitle>
          <CardDescription>
            Download comprehensive inventory data across all locations
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label>Master Inventory Report</Label>
              <p className="text-sm text-muted-foreground">
                Exports all SKUs across all locations with stock levels, sales data, and velocity metrics
              </p>
            </div>
            <MasterInventoryDownloadButton />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

function MasterInventoryDownloadButton() {
  const { organization } = useOrganization();
  const getMasterInventoryReport = trpc.organization.getMasterInventoryReport.useQuery(
    {},
    {
      enabled: false,
    },
  );

  const handleDownload = async () => {
    try {
      toast.info('Generating master inventory report...');

      const data = await getMasterInventoryReport.refetch();

      if (!data.data || data.data.length === 0) {
        toast.warning('No inventory data found');
        return;
      }

      downloadMasterInventoryCsv(data.data, organization?.slug || 'inventory');
      toast.success(`Master inventory report downloaded (${data.data.length} rows)`);
    } catch (error) {
      console.error('Failed to download master inventory report:', error);
      toast.error('Failed to generate report. Please try again.');
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="default"
      onClick={handleDownload}
      disabled={getMasterInventoryReport.isLoading || getMasterInventoryReport.isFetching}
    >
      {getMasterInventoryReport.isLoading || getMasterInventoryReport.isFetching ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Generating...
        </>
      ) : (
        <>
          <Download className="mr-2 h-4 w-4" />
          Download CSV
        </>
      )}
    </Button>
  );
}
